<template>
  <div class="relative flex justify-end items-center">
    <button @click="isOpen = !isOpen"  id="project-options-menu-0" aria-haspopup="true" type="button" class="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none  focus:ring-offset-2 focus:ring-purple-500">
      <span class="sr-only">Open options</span>
      <!-- Heroicon name: dots-vertical -->
      <svg class="w-5 h-5 text-pink" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
      </svg>
    </button>


    <transition  v-if="isOpen"
        name="campaign-card-crud-transition"
        enter-class="transition ease-out duration-100 transform"
        enter-active-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-class="transition ease-in duration-75 transform"
        leave-active-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
      <div v-click-outside="setOpenToFalse"
            class="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200" role="menu" aria-orientation="vertical" aria-labelledby="project-options-menu-0">

        <div class="py-1" role="none">
          <update-campaign-card-modal
              :key="campaignCard.id"
              :campaign-card="campaignCard"
              :campaign-card-type="formType"
          />
        </div>

        <div class="py-1" role="none">
          <a href="#" @click.prevent="removeCampaignCard(campaignCard.id)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: trash -->
            <svg class="mr-3 h-5 w-5 text-pink-500 group-hover:text-pink-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            Delete
          </a>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      campaignCard: null,
      formType: null,
    },
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      setOpenToFalse() {
        this.isOpen = false;
      },
      removeCampaignCard(id){
        axios.post('/remove-campaign-card', {id: id})
            .then(response => {
              this.$notify({text: 'Card removed',type: 'success', })

              setTimeout(() => {
                this.isOpen = false
                location.reload()
              }, 2000)
            })
      },
    }
  }
</script>

<style scoped>

</style>
